{
  "common.error_generic": "Un problème est survenu. Veuillez réessayer plus tard."
}
